import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Input, Offcanvas, OffcanvasBody, OffcanvasHeader, Spinner } from 'reactstrap';

import moment from 'moment';

// actions
import QRCode from 'qrcode.react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { AnalysisRequestLastUpdate } from '../../../components/Common/AnalysisRequestLastUpdate';
import { ConfirmationModal } from '../../../components/Common/ConfirmationModal';
import Table1 from '../../../components/Common/TableContainer';
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal';
import { requestStatus, sampleValidationStatus, statuses, mainLabRequestStatus } from '../../../constants';
import { BaseCustomButton, BaseSelectComponent, DateUtil, labRequestStatus, sampleMode, userRoles } from '../../../shared';
import { getKinds } from '../../../store/catalogs/Kinds/actions';
import { getLocations } from '../../../store/catalogs/Locations/actions';
import { getRegions } from '../../../store/catalogs/Regions/actions';
import { getUnitMeasures } from '../../../store/catalogs/UnitMeasures/actions';
import {
  addNewLabRequestSampleControl,
  addNewLabRequestSampleProcess,
  deleteLabRequestSample,
  getLabRequestSamples,
  updateLabRequestSample,
  updateLabRequestSampleCheck,
  massiveSampleStatusUpdate,
} from '../../../store/labCitec/labRequestSamples/actions';
import { CreateSamplesModal } from './CreateSamplesModal';

// Formik validation
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { NotifyButton } from '../../LabCitec/Components';
import { labRequestSampleStep } from '../../../shared/config/labRequestSampleSteps';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../../constants/tables';

export const LabCitecRequestSampleTab = ({ props, updateSampleStatus, id, labRequest, users, refresh, activeTab, status, generalStatus }) => {
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);

  const [isUpdate, setIsUpdate] = useState(false);
  const [isClone, setIsClone] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  const [rowInfo2, setRowInfo2] = useState();
  // No checkboxes needed, actions apply to all samples

  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  // Canvas Hook
  const [showCanvas, setShowCanvas] = useState(false);

  //Is Enabled Fields
  const [disabled, setDisabled] = useState(true);

  const obj = JSON.parse(localStorage.getItem("authUser"))

  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

  const [user, setUser] = useState(obj.id);

  // * Redux
  const dispatch = useDispatch();

  const reRender = () => {
    refresh();
    dispatch(getLabRequestSamples(`?limit=${pageSize}&page=0&labRequest=${id}`));
  }

  useEffect(() => {
    dispatch(getLabRequestSamples(`?limit=${pageSize}&page=0&labRequest=${id}`));
    if (!kinds || kinds.length === 0) dispatch(getKinds(`?limit=100&page=0`));
    if (!unitmeasures || unitmeasures.length === 0) dispatch(getUnitMeasures(`?limit=2050&page=0`));
    if (!locations || locations.length === 0) dispatch(getLocations(`?limit=100&page=0`));
    if (!regions || regions.length === 0) dispatch(getRegions(`?limit=4000&page=0`));
  }, [id, pageSize, activeTab]);

  const { labRequest1, labRequestSamples, loading, total, currentPage, kinds, unitmeasures, locations, regions } = useSelector(state => ({
    labRequestSamples: state.labRequestSampleReducer.labRequestSamples,
    loading: state.labRequestSampleReducer.loading,
    labRequestSample: state.labRequestSampleReducer.labRequestSample,
    total: state.labRequestSampleReducer.total,
    currentPage: state.labRequestSampleReducer.currentPage,
    kinds: state.kinds.kinds,
    unitmeasures: state.unitMeasures.unitmeasures,
    locations: state.locations.locations,
    regions: state.regions.regions,
    labRequest1: state.labRequestReducer.labRequest,
  }), shallowEqual);
  // * Redux fin

  const existingSample = labRequestSamples?.find(s => s.receivedAt || s.wastedAt || s.receiverUser || s.statusValidation);

  const sampleValidationFormikData = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: rowInfo2?.id ?? '',
      wastedAt: rowInfo2?.wastedAt
        ? DateUtil.formatYYYYMMDD(rowInfo2?.wastedAt)
        : (rowInfo2?.massValidation
            ? (existingSample?.wastedAt
                ? DateUtil.formatYYYYMMDD(existingSample.wastedAt)
                : (labRequest?.startedAt ? moment(labRequest.startedAt).add(60, 'days').format('YYYY-MM-DD') : moment().add(60, 'days').format('YYYY-MM-DD')))
            : ''),
      receivedAt: rowInfo2?.receivedAt
        ? DateUtil.formatYYYYMMDD(rowInfo2?.receivedAt)
        : (rowInfo2?.massValidation
            ? (existingSample?.receivedAt
                ? DateUtil.formatYYYYMMDD(existingSample.receivedAt)
                : (labRequest?.startedAt ? DateUtil.formatYYYYMMDD(labRequest.startedAt) : moment().format('YYYY-MM-DD')))
            : ''),
      statusValidation: rowInfo2?.statusValidation || (rowInfo2?.massValidation && existingSample?.statusValidation) || 'Completo',
      receiverUser: rowInfo2?.receiverUser?.id || (rowInfo2?.massValidation && existingSample?.receiverUser?.id) || obj?.id || '',
      validateObservations: (rowInfo2?.validateObservations && rowInfo2?.validateObservations.trim() !== '')
        ? rowInfo2.validateObservations
        : (rowInfo2?.massValidation && existingSample?.validateObservations)
          ? existingSample.validateObservations
          : 'Muestra completa y en buen estado',
    },
    validationSchema: Yup.object({
      statusValidation: Yup.string().required('Seleccione un estatus'),
      receiverUser: Yup.string().required("Seleccione un usuario"),
      validateObservations: Yup.string().required("Ingrese las observaciones"),
    }),
    onSubmit: (values, { resetForm }) => {
      updateCanvas(values);
      resetForm();
      setShowCanvas(false);
    },
  });

  const booleanValidation = React.useMemo(
    () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
    [generalStatus]
  );

  const columns2 = React.useMemo(
    () => [
      {
        Header: () => null,
        id: 'expander',
        width: '5%',
        Cell: ({ row }) => {
          return (
            <div>
              <div className="row">
                <span {...row.getToggleRowExpandedProps()} style={{ cursor: 'pointer', marginBottom: '10px' }}>
                  {row.isExpanded ? '▼' : '►'}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        Header: 'Información de la muestra',
        width: '85%',
        columns: [
          {
            id: 1,
            Cell: ({ row }) => (
              <div>
                <div className='text-left pb-2'><b>Código de Muestra:</b> {row.original.sampleControlIdentifier ?? '-'}</div>
                {
                  row.original.step === labRequestSampleStep.sampleControl ? <QRCode value={row.original.labRequest?.sampleControlIdentifier} size={60} /> : null
                }
                <hr className='text-success' />
                {row.original.step === labRequestSampleStep.sampleControl ? <div className='text-success fw-bold'>En control de muestras</div> : null}
                <div className='text-left'><b>Folio de Muestra:</b> {row.original.serviceIdentifier ?? '-'}</div>
                <div className='text-left'><b>Número de Solicitud:</b> {row.original.labRequest?.code ?? '-'}</div>
              </div>
            ),
          },
          {
            id: 2,
            Cell: ({ row }) => (
              <div>
                <div className='text-left'><b>Cliente Proveedor:</b> {row.original.labRequest?.customer?.name ?? '-'}</div>
                <div className='text-left'><b>Asesor Técnico:</b> {row.original.labRequest?.technicalAdviser ? `${row.original.labRequest.technicalAdviser.name} ${row.original.labRequest.technicalAdviser.surname ?? ''}`.trim() : '-'}</div>
                <hr className='text-success' />
                <div className='text-left'><b>Cantidad:</b> {row.original.quantity ?? '-'}      <b>UM:</b> {row.original.unitMeasure?.name ?? '-'}</div>
                <div className='text-left'><b>Descripción:</b> {row.original.name ?? '-'}</div>
              </div>
            ),
          },
          {
            id: 3,
            Cell: ({ row }) => (
              <div>
                <div className='text-left'><b>Clase:</b> {row.original.kind?.name ?? '-'}</div>
                {row.original.location?.name ? (
                  <div className='text-left'><b>Región:</b> {row.original.location.name}</div>
                ) : null}
                <div className='text-left'><b>Localidad:</b> {`${row.original.region?.state}-${row.original.region?.municipality}` ?? '-'}</div>
                <hr className='text-success' />
                <div className='text-left'><b>Fecha de muestreo:</b> {row.original.dateAt ? moment.utc(row.original.dateAt).format("YYYY-MM-DD") : '-'}</div>
                <div className='text-left'><b>Fechas estimada de recepción:</b> {row.original.estimateReceivedAt ? moment.utc(row.original.estimateReceivedAt).format("YYYY-MM-DD") : '-'}</div>
              </div>
            ),
          },
          {
            Header: 'Estatus',
            width: "8%",
            Cell: ({ row }) => (
              row.original.statusValidation === 'Completo' ?
                <div className='text-success'>{row.original.statusValidation}</div> :
                row.original.statusValidation === 'Incompleto' ?
                  <div className='text-danger'>{row.original.statusValidation}</div> :
                  <div className='text-warning'>{row.original.statusValidation}</div>
            ),
          },
          {
            width: '10%',
            Header: "Acciones",
            Cell: ({ row }) => (

              <div className="page-title-box d-flex align-items-center justify-content-center row">
                <BaseCustomButton
                  disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING) || generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED}
                  color='primary'
                  outline
                  className="col-10 mb-2 p-1"
                  icon="mdi-lead-pencil mdi-18px"
                  label="Editar"
                  onClick={() => { onUpdate(row.original) }}
                />
                <BaseCustomButton
                  disabled={labRequest.requestStatus === labRequestStatus.accepted || labRequest.requestStatus === labRequestStatus.rejected}
                  color='primary'
                  outline
                  className="col-10 mb-2 p-1"
                  icon="mdi-content-copy mdi-18px"
                  label="Clonar"
                  onClick={() => onClone(row.original)}
                />
                <BaseCustomButton
                  disabled={!row.original.evaluationFlag || (role === userRoles.technicalAdvisor) || (labRequest1?.generalStatus === statuses.FINISHED || labRequest1?.generalStatus === statuses.CANCELLED)}
                  color='primary'
                  outline
                  className="col-10 mb-2 p-1"
                  icon="mdi-eye mdi-18px"
                  label="Validar"
                  onClick={() => openCanvas(row.original)}
                />
                <BaseCustomButton
                  disabled={
                    generalStatus === statuses.FINISHED ||
                    generalStatus === statuses.CANCELLED ||
                    (status === statuses.ACCEPTED && role !== userRoles.coordinator) ||
                    (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING && status !== statuses.ACCEPTED)
                  }
                  color='danger'
                  outline
                  className="col-10 p-1"
                  icon="mdi-close-circle mdi-18px"
                  label="Eliminar"
                  onClick={() => onDelete(row.original)}
                />
              </div>
            ),
          },
        ],
      },
    ],
    [role, status, generalStatus, labRequest1]
  )

  const openCanvas = (values) => {
    setShowCanvas(true);
    setRowInfo2(values);
    setDisabled(false);
  };

  const handleReceivedAtChange = (e) => {
    const newDate = e.target.value;
    sampleValidationFormikData.setFieldValue('receivedAt', newDate);
    if (newDate) {
      sampleValidationFormikData.setFieldValue('wastedAt', moment(newDate).add(60, 'days').format('YYYY-MM-DD'));
    }
  };

  const recarga = () => {
    window.location.reload();
  };

  const sampleStatusFormikData = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.id),
      trackingStatus: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.trackingStatus) ?? ''
    },
    validationSchema: Yup.object({
      trackingStatus: Yup.string().required("Defina el estatus"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (values.trackingStatus === 'Autorizado') {
        const hasPendingSamples = labRequestSamples && labRequestSamples.some(sample => sample.statusValidation !== 'Completo');
        if (hasPendingSamples) {
          toast.error("Existen muestras pendientes por validar");
          return;
        }
      }
      updateSampleStatus(values)
      setTimeout(recarga, 900);
    },
  });

  const onUpdate = (values) => {
    setIsUpdate(true)
    setRowInfo(values)
    setShowModal1(true)
  }

  const onClone = (values) => {
    setIsUpdate(false)
    setIsClone(true)
    setRowInfo(values)
    setShowModal1(true)
  }

  const onDelete = (values) => {
    setRowInfo(values)
    setShowModal2(true)
  }

  const getPagination = (params) => {
    dispatch(getLabRequestSamples(`${params}&labRequest=${id}`))
  }

  const onDeleteConfirmation = () => {
    dispatch(deleteLabRequestSample(rowInfo))
    setRowInfo('')
  }

  const modalClose = () => {
    setIsUpdate(false)
    setRowInfo('')
  }

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      <div>
        <div className='text-left'>Observaciones: {row?.original?.observations ?? '-'}</div>
      </div>
    ),
    []
  )

  const onAccept = () => sampleStatusFormikData.submitForm();

  const handleSampleEvaluation = () => {
    const updateObj = {
      evaluationFlag: true,
      step: labRequestSampleStep.analysisRequest,
      labRequestSamples: labRequestSamples.map(s => s.id)
    }
    dispatch(addNewLabRequestSampleProcess(updateObj))
    setTimeout(
      () => {
        refresh()
        dispatch(getLabRequestSamples(`?limit=${pageSize}&page=${DEFAULT_PAGE}&labRequest=${id}`))
      }
      , 1000)
  }

  const handleSampleControl = () => {
    const updateObj = {
      evaluationFlag: true,
      step: labRequestSampleStep.sampleControl,
      labRequestSamples: labRequestSamples.map(s => s.id)
    }
    dispatch(addNewLabRequestSampleControl(updateObj))
    setTimeout(
      () => {
        refresh()
        dispatch(getLabRequestSamples(`?limit=${pageSize}&page=${DEFAULT_PAGE}&labRequest=${id}`))
      }
      , 1000)
  }

  const onUpdateCanvas = () => {
    if (disabled) {
      setDisabled(false);
    } else {
      sampleValidationFormikData.handleSubmit();
    }
  };

  const onCloseCanvas = () => {
    setDisabled(true)
  }

  const updateCanvas = (values) => {
    // Check if the Offcanvas was opened for mass validation
    if (rowInfo2?.massValidation) {
      // MASSIVE UPDATE
      dispatch(massiveSampleStatusUpdate(id, values));

      setTimeout(reRender, 600);
    } else {
      // SINGLE UPDATE
      dispatch(updateLabRequestSample({ ...values }));

      setTimeout(reRender, 600);
    }

    setDisabled(true);
  };


  const setReceiverUser = (value) => {
    sampleValidationFormikData.setFieldValue('receiverUser', value);
  }

  return (
    <div className="d-flex justify-content-center">
      <Container fluid className="" >
        <Col className="col-12" style={{ padding: 20 }}>
          <Form
            className="form-horizontal mt-2 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              sampleStatusFormikData.handleSubmit();
              return false;
            }}
          >
            <div className="d-flex justify-content-between align-items-end mb-4 mt-5 flex-wrap gap-3">
              <div>
                <AnalysisRequestLastUpdate
                  client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.updatedBy?.surname ?? ''}`}
                  date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`}
                />
              </div>
              <div className="d-flex align-items-end gap-2 flex-wrap">
                <div>
                  <BaseCustomButton
                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED) || labRequestSamples?.length === 0}
                    color='warning'
                    className='rounded-3 d-flex align-items-center justify-content-center py-0'
                    style={{ height: '40px', width: '260px' }}
                    icon='mdi-lock mdi-18px'
                    label='Evaluar Muestras'
                    onClick={() => { setShowModal4(true) }}
                  />
                </div>
                <div>
                  <BaseCustomButton
                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED) || labRequestSamples?.length === 0}
                    color='primary'
                    className='rounded-3 d-flex align-items-center justify-content-center py-0'
                    style={{ height: '40px', width: '260px' }}
                    icon='mdi-check-circle mdi-18px'
                    label='Control Muestras'
                    onClick={() => { setShowModal5(true) }}
                  />
                </div>
                <div style={{ width: '260px' }}>
                  <label htmlFor="exampleInputEmail1" className='text-primary ml-1 mb-1 d-block'>Estatus</label>
                  <BaseSelectComponent
                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                    value={sampleStatusFormikData.values.trackingStatus || ""}
                    options={requestStatus.map((dir) => ({ value: dir.id, label: dir.value }))}
                    onChange={(value) => sampleStatusFormikData.setFieldValue('trackingStatus', value)}
                    placeholder="Seleccione el estatus"
                    error="Seleccione el estatus"
                    touched={sampleStatusFormikData.errors.trackingStatus}
                    status={sampleStatusFormikData.errors.trackingStatus ? 'error' : ''}
                    className="text-primary"
                    size="large"
                  />
                </div>
                <div>
                  <NotifyButton
                    pathName={`/process-notification/${id}`}
                    booleanValidation={booleanValidation}
                    style={{ height: '40px', width: '120px' }}
                    className="d-flex align-items-center justify-content-center py-0"
                  />
                </div>
                <div>
                  <BaseCustomButton
                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                    color='success'
                    className='rounded-3 d-flex align-items-center justify-content-center py-0'
                    style={{ height: '40px', width: '120px' }}
                    icon='mdi-content-save mdi-18px'
                    label='Guardar'
                    onClick={() => { setShowModal3(true) }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <BaseCustomButton
                disabled={
                  // Instead of using "row.original.evaluationFlag", check if there exists any sample
                  !labRequestSamples.some(sample => sample.evaluationFlag) ||
                  (role === userRoles.technicalAdvisor) ||
                  (labRequest1?.generalStatus === statuses.FINISHED ||
                    labRequest1?.generalStatus === statuses.CANCELLED)
                }
                className='btn btn-info rounded-3 me-2'
                icon='mdi-checkbox-marked-circle-outline mdi-18px'
                label='Validación Masiva'
                onClick={() => openCanvas({ massValidation: true })}
              />
              <BaseCustomButton
                disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                color='primary'
                className='w-40'
                icon='mdi-plus mdi-18px'
                label='Registrar Muestra'
                onClick={() => { setShowModal1(!showModal1) }}
              />
            </div>
          </Form>

          <Table1
            loading={loading}
            isAddTableBorderStrap
            renderRowSubComponent={renderRowSubComponent}
            currentPage={currentPage}
            getPagination={getPagination}
            total={total}
            columns={columns2}
            data={labRequestSamples}
            onPageSizeChange={(newSize) => setPageSize(newSize)}
          />
          <ConfirmationModal
            onAccept={onAccept}
            showModal={showModal3}
            setShowModal={setShowModal3}
            message='¿Estás seguro de cambiar el estatus de la solicitud de muestras?'
          />
          <ConfirmationModal
            onAccept={handleSampleEvaluation}
            showModal={showModal4}
            setShowModal={setShowModal4}
            message={(labRequestSamples.length > 0)
              ? 'Esta acción dará inicio a la fecha de trabajos y habilitará la evaluación de todas las muestras, ¿Desea continuar?'
              : 'No existen muestras'
            } />
          <ConfirmationModal onAccept={handleSampleControl} showModal={showModal5} setShowModal={setShowModal5} message='Esta acción asignará las muestras seleccionadas al control de muestras, ¿Desea continuar?' />

          <CreateSamplesModal
            kinds={kinds}
            unitMeasures={unitmeasures}
            regions={regions}
            locations={locations}
            rowInfo={rowInfo}
            isUpdate={isUpdate}
            isClone={isClone}
            props={props}
            setShowModal={setShowModal1}
            showModal={showModal1}
            modalHeader='Registro de Muestras'
            modalClose={modalClose}
            labRequest={labRequest}
            mode={sampleMode.labRequest}
            senderUser={user}
            id={id}
            pageSize={pageSize}
          />

          <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Muestras' modalBodyLabel={'¿Está seguro que desea borrar la muestra seleccionada?'} />
          <br />
          <Offcanvas
            isOpen={showCanvas}
            onClosed={onCloseCanvas}
            direction="end"
            toggle={() => { setShowCanvas(!showCanvas) }}
          >
            <OffcanvasHeader className='text-primary' toggle={() => { setShowCanvas(!showCanvas) }}>
              Validación de Muestras
            </OffcanvasHeader>
            <OffcanvasBody>
              <div className="d-flex align-items-center justify-content-end">
                <BaseCustomButton
                  color='success'
                  className="col-10 mb-2 p-2 w-auto"
                  icon={disabled ? "mdi-lead-pencil mdi-18px" : "mdi-content-save mdi-18px"}
                  label={disabled ? 'Editar' : 'Guardar'}
                  onClick={() => { onUpdateCanvas() }}
                />
              </div>
              {
                loading ?
                  <div className="text-center py-5">
                    <Spinner
                      color="primary"
                    >
                    </Spinner>
                    <div className="row-center mt-2">
                      {' '}Cargando...
                    </div>
                  </div> :
                  <Form
                    className="form-horizontal mt-0 mb-1"
                    onSubmit={(e) => {
                      e.preventDefault();
                      sampleValidationFormikData.handleSubmit();
                      return false;
                    }}
                  >
                    <div className='row'>
                      <div className='row mt-1 mb-3'>
                        <div className="col-3 col-md-12">
                          <label htmlFor="exampleFormControlInput1" className='text-primary'>Estatus de Solicitud</label>
                          <BaseSelectComponent
                            disabled={disabled}
                            value={sampleValidationFormikData.values.statusValidation || ""}
                            options={sampleValidationStatus.map((dir) => ({ value: dir.id, label: dir.value }))}
                            onChange={(value) => sampleValidationFormikData.setFieldValue('statusValidation', value)}
                            placeholder="Seleccione el estatus de validación"
                            error="Seleccione el estatus de validación"
                            touched={sampleValidationFormikData.errors.statusValidation}
                            status={sampleValidationFormikData.errors.statusValidation ? 'error' : ''}
                            className="text-primary"
                          />
                        </div>
                      </div>
                      <div className='row mt-2 mb-3'>
                        <div className="col-3 col-md-12">
                          <label className='text-primary'>Personal que recibe</label>
                          <BaseSelectComponent
                            disabled={disabled}
                            placeholder="Seleccione Usuario..."
                            options={users.map((user) => ({
                              value: user.id,
                              label: `${user.name ?? "-"} ${user.surname ?? ""}`,
                            }))}
                            value={sampleValidationFormikData.values.receiverUser}
                            onChange={(value) => setReceiverUser(value)}
                            error="Seleccione un usuario"
                            touched={sampleValidationFormikData.errors.receiverUser}
                            status={sampleValidationFormikData.errors.receiverUser ? 'error' : ''}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className="col-3 col-md-12">
                          <label className='text-primary'>Firma</label>
                          <Input
                            type="text"
                            className="form-control text-primary rounded-3"
                            id="signature"
                            placeholder='Firma'
                            disabled={true}
                            value={users.find(user => user.id === sampleValidationFormikData.values.receiverUser)?.signature ?? '-'}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className="col-3 col-md-12">
                          <label className='text-primary ml-1'>Fecha de Recepción de Muestra</label>
                          <div className='w-100 me-3'>
                            <Input
                              disabled={disabled}
                              name="receivedAt"
                              className="form-control rounded-3 text-primary"
                              type='date'
                              onChange={handleReceivedAtChange}
                              onBlur={sampleValidationFormikData.handleBlur}
                              value={sampleValidationFormikData.values.receivedAt || ""}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className="col-3 col-md-12">
                          <label className='text-primary ml-1'>Fecha de Desecho</label>
                          <div className='w-100 me-3'>
                            <Input
                              disabled={true}
                              name="wastedAt"
                              className="form-control rounded-3 text-primary"
                              type='date'
                              onChange={sampleValidationFormikData.handleChange}
                              onBlur={sampleValidationFormikData.handleBlur}
                              value={sampleValidationFormikData.values.wastedAt || ""}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className="col-3 col-md-12">
                          <label className='text-primary'>Observaciones</label>
                          <Input
                            name="validateObservations"
                            className="form-control text-primary"
                            placeholder="Observaciones"
                            type="textarea"
                            disabled={disabled}
                            onChange={sampleValidationFormikData.handleChange}
                            onBlur={sampleValidationFormikData.handleBlur}
                            value={sampleValidationFormikData.values.validateObservations || ""}
                            invalid={
                              !!(sampleValidationFormikData.touched.validateObservations && sampleValidationFormikData.errors.validateObservations)
                            }
                            height={300}
                          />
                        </div>
                      </div>
                    </div>
                  </Form>
              }
            </OffcanvasBody>
          </Offcanvas>
        </Col>
      </Container>
    </div>
  )
}
